export default __webpack_public_path__ + "static/media/rotax_logo.3ad2ecc4.svg";